import React, { useEffect, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import Axios from 'axios';

import { BackDropLoad } from './LoadingBackDrop';
import { Loading } from './Loading';
import { UserContext, SnackbarContext } from './userContext';
import { AutoCompLoc } from './AutoCompLoc.jsx';
import {
  AccountHeader,
  FormCard,
  Field,
  PrimaryButton,
  Icon,
} from './myacc/primitives';

export const MyAccUpdateSupDetails = () => {
  const history = useNavigate();

  const [loading, setLoading] = useState(true);

  const [supname, setSupname] = useState('');
  const [fname, setFname] = useState('');
  const [lname, setLname] = useState('');
  const [email, setEmail] = useState('');
  const [loc, setLoc] = useState('');

  const [error, setError] = useState(0);
  const [wait, setWait] = useState(false);

  const { user, setUser } = useContext(UserContext);
  const { setSnack } = useContext(SnackbarContext);

  useEffect(() => {
    const formData = { uid: user.user_id, role: user.user_role, cat: user.category_ids };
    Axios.post('/new_apis/getuserdata', formData, { headers: { tkn: user.token } }).then((res) => {
      if (res.data.status === 1) {
        const d = res.data.data;
        if (d.supplier_name !== null) setSupname(d.supplier_name);
        if (d.user_full_name !== null) setFname(d.user_full_name);
        if (d.user_last_name !== null) setLname(d.user_last_name);
        if (d.user_email !== null) setEmail(d.user_email);
        if (d.area_ids !== null) setLoc(d.area_ids);
        setLoading(false);
      } else if (res.data.status === 3) {
        history('/');
        setSnack({ message: res.data.msg, type: 'warning', open: true, direction: 'left' });
      } else if (res.data.status === 4) {
        setUser(null);
        history('/');
        localStorage.removeItem('estkn');
        setSnack({ message: res.data.msg, type: 'warning', open: true, direction: 'left' });
      }
    });
  }, []); // eslint-disable-line

  const updatedetails = (e) => {
    e.preventDefault();
    setError(0);
    if (supname === '') {
      setError(1);
      setSnack({ message: 'Please enter your registered supplier / service provider name.', type: 'error', open: true, direction: 'center' });
      return;
    }
    if (fname === '') {
      setError(2);
      setSnack({ message: 'Please enter your first name.', type: 'error', open: true, direction: 'center' });
      return;
    }
    if (!email.includes('@')) {
      setError(3);
      setSnack({ message: 'Please enter a valid email ID.', type: 'error', open: true, direction: 'center' });
      return;
    }
    if (loc === '') {
      setError(4);
      setSnack({ message: 'Please enter your location.', type: 'error', open: true, direction: 'center' });
      return;
    }

    const formData = {
      supname, fname, lname, email, loc,
      uid: user.user_id, role: user.user_role, cat: user.category_ids,
    };
    setWait(true);
    Axios.post('/new_apis/updatedetails', formData, { headers: { tkn: user.token } }).then((res) => {
      if (res.data.status === 1) {
        setUser((prev) => ({
          ...prev,
          user_full_name: res.data.fname,
          user_last_name: res.data.lname,
          user_email: res.data.email,
          name: `${res.data.fname} ${res.data.lname}`,
        }));
        setWait(false);
        setSnack({ message: res.data.msg, type: 'success', open: true, direction: 'center' });
      } else if (res.data.status === 2) {
        setWait(false);
        setSnack({ message: res.data.msg, type: 'error', open: true, direction: 'center' });
      } else if (res.data.status === 3) {
        setWait(false);
        setSnack({ message: res.data.msg, type: 'warning', open: true, direction: 'left' });
        history('/');
      } else if (res.data.status === 4) {
        setUser(null);
        setWait(false);
        localStorage.removeItem('estkn');
        setSnack({ message: res.data.msg, type: 'warning', open: true, direction: 'left' });
        history('/');
      }
    });
  };

  if (loading) return <Loading />;

  return (
    <>
      <BackDropLoad wait={wait} />
      <AccountHeader
        kicker="Account"
        title="Update details"
        subtitle="Keep your business information up to date."
      />

      <FormCard onSubmit={updatedetails}>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
          <Field
            label="Service provider / supplier name"
            value={supname}
            onChange={(e) => setSupname(e.target.value)}
            error={error === 1}
            errorMsg="Please enter a name."
            required
          />
          <Field
            label="First name"
            value={fname}
            onChange={(e) => setFname(e.target.value)}
            error={error === 2}
            errorMsg="Please enter your first name."
            required
          />
          <Field
            label="Last name"
            value={lname}
            onChange={(e) => setLname(e.target.value)}
          />
          <Field
            label="Email ID"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            error={error === 3}
            errorMsg="Please enter a valid email ID."
            required
            icon={<Icon.Mail className="h-4 w-4" />}
          />
          <div className="sm:col-span-2">
            <label className="mb-1.5 block text-[10.5px] font-bold uppercase tracking-[0.14em] text-fg-tertiary">
              Location <span className="ml-1 text-amber">*</span>
            </label>
            <AutoCompLoc compact error={error === 4} loc={loc} setloc={(l) => setLoc(l)} label="Where" required={false} />
            {error === 4 && <div className="mt-1.5 text-[11px] text-red-400">Please select your location.</div>}
          </div>

          <div className="sm:col-span-2 pt-1">
            <PrimaryButton type="submit" loading={wait} icon={<Icon.Save className="h-4 w-4" />}>
              {wait ? 'Please wait…' : 'Update'}
            </PrimaryButton>
          </div>
        </div>
      </FormCard>
    </>
  );
};
